import React from "react";
import ReactDom from "react-dom";
import {Provider} from "react-redux";
import {composeWithDevTools} from "redux-devtools-extension";
import {createStore, applyMiddleware} from "redux";
import thunk from "redux-thunk";

import {App} from "./components/app";
import {Operation as DataOperation, ActionCreator as DataActionCreator, ActionCreator} from "./reducers/data/data";
import {createAPI} from "./api";
import {getDataError} from "./reducers/data/selectors";
import {reducer} from "./reducers/reducer";


const onFailRequest = (error) => {
  if (!getDataError(store.getState())) {
    store.dispatch(DataActionCreator.setDataError(error));
  }
};

const api = createAPI(onFailRequest);

const store = createStore(
    reducer,
    composeWithDevTools(
        applyMiddleware(thunk.withExtraArgument(api))
    )
);

const renderDom = () => {
  ReactDom.render(
      <Provider store={store}>
        <App />
      </Provider>,
      document.querySelector(`#root`)
  );
};

const archiveLoader = store.dispatch(DataOperation.loadArchive());
const periodsLoader = store.dispatch(DataOperation.loadPeriods());

Promise.allSettled([archiveLoader, periodsLoader])
  .then(() => {
    store.dispatch(ActionCreator.setDataError(null));
    store.dispatch(DataOperation.loadCurrent())
      .then((response) => {
        if (response) {
          const currentPeriodId = response.periodId;

          store.dispatch(DataOperation.loadPools(currentPeriodId))
            .then(() => {
              renderDom();
            });
        } else {
          renderDom();
        }
      });
  });
